import { analytics } from 'libs';
import { Select } from 'components/common';
import Filter from './Filter';

const options = [
  { label: '6 Month', value: '12' },
  { label: '1 Year', value: '1' },
  { label: '2 Year', value: '2' },
  { label: '3 Year', value: '3' },
  { label: '4 Year', value: '4' },
  { label: '5 Year', value: '5' },
  { label: '6 Year', value: '6' },
  { label: '7 Year', value: '7' },
  { label: '10 Year', value: '10' },
];

interface TermFilterProps {
  filters: { term_id?: (number | string)[] };
  onFilter: (update: { term_id: string[] | null }) => void;
  size: 'default' | 'lg';
}

interface TermOption {
  label: string;
  value: string;
}

const TermFilter = ({ filters, onFilter }: TermFilterProps) => {
  const onChange = (selected: TermOption[] | null) => {
    const termIds = selected?.map((option) => option.value) || [];

    analytics.productSearch.filter({ term: termIds.length ? termIds : 'cleared' });

    onFilter({ term_id: termIds.length ? termIds : null });
  };

  const selectedOptions = () => {
    const termIds = filters.term_id?.map(String) || [];

    return termIds.length ? options.filter((option) => termIds.includes(option.value)) : null;
  };

  return (
    <Filter name="Term">
      <Select
        className="form-react-select"
        clearValue={null}
        closeMenuOnSelect={false}
        isMulti
        onChange={onChange}
        options={options}
        placeholder="All"
        selected={selectedOptions()}
        testId="filter-term"
      />
    </Filter>
  );
};

export default TermFilter;
